import { useLazyQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";

import { fetchJourneys, GetJourneysResponse } from "./queries";
import { SpotlightJourneysItem } from "./SpotlightJourneysItem";

export const useGetSearchJourneys = (onCallback: () => void) => {
    const navigate = useNavigate();
    const [getJourneys, { loading }] = useLazyQuery<GetJourneysResponse>(fetchJourneys);

    const handleGetJourneys = async (searchValue: string) => {
        const journeys = await getJourneys({
            variables: {
                queryParams: { filterBy: [{ key: "name", value: searchValue, operator: "contains" }] },
            },
        });
        const journeysData = journeys.data?.getJourneys.items.map((item) => {
            const route = `/journeys/${item.id}`;

            return {
                label: (
                    <SpotlightJourneysItem
                        name={item.name}
                        description={item.description}
                        searchValue={searchValue}
                        route={route}
                        onCallback={() => {
                            onCallback();
                            navigate(route);
                        }}
                    />
                ),
                value: item.id,
            };
        });

        if (!journeysData?.length || !searchValue) {
            return [];
        }

        return [
            {
                label: "Journeys",
                options: journeysData,
            },
        ];
    };

    return {
        getJourneys: handleGetJourneys,
        loading,
    };
};
